export type WeekStatusKey = 'success' | 'partial' | 'missed';

export const getWeekStatus = (progressCount: number, goalCount: number): WeekStatusKey => {
  if (goalCount === 0) return 'missed';
  if (progressCount >= goalCount) return 'success';
  if (progressCount > 0) return 'partial';
  return 'missed';
};
